import { updateURL, removeQueryStringParameter, QueryString, objectToUrlQuery, formatMoney } from '../functions';
import Swal from 'sweetalert2';


$(document).ready(function() {

	$(document).on('click', '.change-car-btn', function(e) {
		var parameters = QueryString(null);

		delete parameters.group;
		delete parameters.insurance;
		delete parameters.extras;

		var url = objectToUrlQuery(parameters);
		window.location = selectCarRoute + (url != '' ? '?' + url : '');
	});

	try {
		if(selectedInsuranceCode != null) {
			updateURL('select-extras', 'Select Extras', 'insurance', selectedInsuranceCode);
		}
	} catch (e) {

	} finally {

	}

	$(document).on('click', '.insurance-item', function(e) {
		e.preventDefault();

		let code = $(this).data('code');
		let title = $(this).data('title');
		let price = $(this).data('price');
		let warranty = $(this).data('warranty');

		$('.depozit-info span').html('&euro; ' + warranty);
		$('.depozit-info').show();

		$('.insurance-item').removeClass('selected');

		$(this).addClass('selected');
		//$('#total').html(total+(1*price));

		updateURL('select-extras', 'Select Extras', 'insurance', code);

		var extraHtml = '<li id="group-insurance-'+code+'">' +
							'<span class="left"><i class="fa fa-check" aria-hidden="true"></i> '+title+'</span><span class="right price-small">&euro; '+price+'</span><div class="clearfix"></div>' +
						'</li>';
		$('#group-insurances-wrapper').html(extraHtml);

		let newTotal = calculateTotal(total);
		$('.total').html(newTotal);
	});

	$(document).on('click', '.extra-item', function(e) {
		e.preventDefault();

		var code = $(this).data('code');
		var title = $(this).data('title');
		var description = $(this).data('description');
		var price = $(this).data('price');
		var pricePerDay = $(this).data('price-per-day');
		var qty = $(this).attr('data-qty');
		var maxQty = $(this).attr('data-max-qty');
		price = price * qty;

		var index = extrasValues.indexOf(code);
	    if (index == -1) {
	        $(this).text('Remove');
	        extrasValues.push(code);
			//$('#extra-qty-wrapper-' + code).show();
			//update price
			//total = total + 1*price;
			//$('#total').html(total);
	    } else {
	        $(this).text('Add');
	        extrasValues.splice(index, 1);
			//$('#extra-qty-wrapper-' + code).hide();
			//update price
			//total = total - 1*price;
			//$('#total').html(total);
	    }

	    if (extrasValues.length > 0) {
	        updateURL('select-extras', 'Select Extras', 'extras', extrasValues.join(','));
			$('.group-extras-container').show();
	    } else {
	        var newURL = removeQueryStringParameter('extras', window.location.href);
	        history.replaceState({ id: 'select-extras' }, 'Select Extras', newURL);
			$('.group-extras-container').hide();
	    }

		if ($('.group-extra-' + code).length > 0) {
			$('.group-extra-' + code).remove();
		} else {
			// var extraHtml = '<li id="group-extra-'+code+'">' +
			// 					'<span class="left"><i class="fa fa-check" aria-hidden="true"></i> '+title+' x <span class="selected-extra-qty-'+code+'">'+qty+'</span></span><span class="right price-small selected-extra-price-'+code+'">&euro; <span>'+price+'</span></span><div class="clearfix"></div>' +
			// 				'</li>';
			var qtyHtml = '';
			if(1*maxQty > 1) {
				qtyHtml = `<div class="card-counter input-group">
						<button class="btn btn-outline-secondary extra-qty-minus" data-code="${code}" type="button"><i class="far fa-minus fa-xs"></i></button>
						<input type="text" class="form-control extra-qty-${code}" value="1" readonly>
						<button class="btn btn-outline-secondary extra-qty-plus" data-code="${code}" type="button"><i class="far fa-plus fa-xs"></i></button>
					</div>`;
			}

			var extraHtml = `<div class="row align-items-center mb-2 group-extra-${code}">
				<div class="col-4 col-md-3 col-lg-3 col-xl-2 text-center">
					<div class="card-info--benefit text-white"
						style="background-color: #ffcc39;">
						<i class="fal fa-check-circle"></i>
					</div>
				</div>
				<div class="col-8 col-lg-9 col-xl-5">
					<h6 class="fw-bold mb-0">${title}</h6>
					<p>${description}</p>
					<div class="d-flex align-items-center mt-2">
						${qtyHtml}
						<a href="javascript:void(0)" data-code="${code}" class="extra-remove-item link-danger remove-item ms-3 d-lg-none"><i class="fas fa-trash-alt"></i></a>
					</div>
				</div>
				<div class="col-xl-5 text-xl-end">
					<div class="d-flex justify-content-between justify-content-lg-end align-items-center">
						<div>
							<div><strong>${pricePerDay} &euro; / per day</strong></div>
							<div><small>${price} &euro; in total</small></div>
						</div>
						<a href="javascript:void(0)" data-code="${code}" class="extra-remove-item link-danger remove-item ms-3 d-none d-lg-block"><i class="fas fa-trash-alt"></i></a>
					</div>
				</div>
			</div>`;
			$('.group-extras-wrapper').append(extraHtml);
		}

		let newTotal = calculateTotal(total);
		$('.total').html(newTotal);
	});

	$(document).on('click', '.extra-remove-item', function(e) {
		var code = $(this).data('code');

		var index = extrasValues.indexOf(code);
	    if (index > -1) {
			extrasValues.splice(index, 1);
		}

		if (extrasValues.length > 0) {
	        updateURL('select-extras', 'Select Extras', 'extras', extrasValues.join(','));
			$('.group-extras-container').show();
	    } else {
	        var newURL = removeQueryStringParameter('extras', window.location.href);
	        history.replaceState({ id: 'select-extras' }, 'Select Extras', newURL);
			$('.group-extras-container').hide();
	    }

		$('.group-extra-' + code).remove();
		$('#extra-item-' + code).text('Add');

		let newTotal = calculateTotal(total);
		$('.total').html(newTotal);
	});

	$(document).on('click', '#send-reservation', function(e) {
        e.preventDefault();

        var parameters = QueryString(null);

		if(!parameters.insurance || parameters.insurance == '') {
			Swal.fire({
				icon: 'error',
				title: 'Oops...',
				text: alertSelectInsurance
			})
			return false;
		}

        var url = objectToUrlQuery(parameters);

        window.location = reservationRoute + (url != '' ? '?' + url : '');
    });

	$(document).on('click', '.extra-qty-plus', function(e) {
		e.preventDefault();
		e.stopPropagation();

		let code = $(this).data('code');
		if (code == null) {
			console.error('invalid code');
			return false;
		}

		if($('#extra-item-' + code).length > 0) {
			let maxQty = $('#extra-item-' + code).attr('data-max-qty');
			let price = $('#extra-item-' + code).data('price');
			let qty = $('#extra-item-' + code).attr('data-qty');
			qty++;

			if (1*qty > 1*maxQty) {
				console.info('max qty');
				return false;
			}

			$('#extra-item-' + code).attr('data-qty', qty);
			$('.extra-qty-' + code).val(qty);
			//$('.selected-extra-qty-' + code).html(qty);
			//$('.selected-extra-price-' + code + ' span').html(price * qty);

			let newTotal = calculateTotal(total);
			$('.total').html(newTotal);

			setExtraQty(code, qty);

			return;
		}

		console.error('element-not-found');
	});

	$(document).on('click', '.extra-qty-minus', function(e) {
		e.preventDefault();
		e.stopPropagation();

		let code = $(this).data('code');
		if (code == null) {
			console.error('invalid code');
			return false;
		}

		if($('#extra-item-' + code).length > 0) {
			let price = $('#extra-item-' + code).data('price');
			let qty = $('#extra-item-' + code).attr('data-qty');
			qty--;
			if(qty < 1) {
				qty = 1;
			}

			$('#extra-item-' + code).attr('data-qty', qty);
			$('.extra-qty-' + code).val(qty);
			//$('.selected-extra-qty-' + code).html(qty);
			//$('.selected-extra-price-' + code + ' span').html(price * qty);

			let newTotal = calculateTotal(total);
			$('.total').html(newTotal);

			setExtraQty(code, qty);

			return;
		}

		console.error('element-not-found');
	});

	$(document).on('click', '.extra-qty', function(e) {
		e.stopPropagation();
	});
});

window.onpopstate = function(event) {
	//console.log(`location: ${document.location}, state: ${JSON.stringify(event.state)}`);
}

function calculateTotal(total) {

	if (QueryString(null).insurance) {
		if ($('#insurance-item-' + QueryString(null).insurance).length > 0) {
			let price = $('#insurance-item-' + QueryString(null).insurance).data('price');
			total += 1*price;
		}
	}

	if (QueryString(null).extras) {
		let extras = QueryString(null).extras.split(',');
		if (extras.length > 0) {
			for (var i = 0; i < extras.length; i++) {
				if ($('#extra-item-' + extras[i]).length > 0) {
					let price = $('#extra-item-' + extras[i]).data('price');
					let qty = $('#extra-item-' + extras[i]).attr('data-qty');
					total += 1*price * qty;
				}
			}
		}
	}

	fees.forEach(function (fee) {
		total += 1*fee.price * fee.quantity;
	});

	return formatMoney(total, 2);
}

function setExtraQty(code, qty) {
	var values = 'code=' + code;
	values += '&qty=' + qty;
	$.ajax({
		type: "GET",
		url: baseURL + "/set-extra-qty",
		data: values,
		success: function(response) {

		},
		error(error) {

		}
	});
}



// WEBPACK FOOTER //
// ./resources/assets/js/modules/group.js